import React from "react";
import PMSHelpManual from "./PMSHelpManual";

export default function HelpManual() {
  return (
    <div>
      {/* <h3>Help document:</h3> */}
      <div className="mt-3 config-hotel">
        <PMSHelpManual />
      </div>
    </div>
  );
}
